<template>
  <div class="app-organization">

    <input-title :required="options.required" :description="options.description"/>

    <div
      v-if="organizations.length"
      class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="'input-group-' + i"
        class="input-group">
        <el-select
          v-model="valueLocal[i]"
          :key="'input-' + i"
          clearable
          @change="onChange"
          v-bind="widgetOptions">
          <el-option
            v-for="(o, j) in organizations"
            :key="'option-' + j"
            :label="o.label"
            :value="o.value">
          </el-option>
        </el-select>

      <div v-if="error[i]" class="ait_message ait_message--error">
        {{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
      organizations: [],
    };
  },

  created() {
    // Process local options for this widget type
    this.widgetOptions.placeholder = this.options.placeholder ?
      this.options.placeholder : 'Выберите организацию...';
    // Get organizations
    axios.get('organizations').then((response) => {
      response.data.forEach((el) => {
        const OrganizationId = el.OrganizationId;
        // const Organization = el.Name;
        const Organization = el.ShortName;
        this.organizations.push({
          value: OrganizationId,
          label: Organization,
        });
      });
    });
  },

  methods: {

    setValue(value) {
      this.valueLocal = [];
      value.forEach((v) => {
        this.valueLocal.push(v.OrganizationId);
      });
    },

    onChange(val) {
      this.$emit('change', val);
    },

    getValue() {
      const result = [];
      this.valueLocal.forEach((value, i) => {
        this.organizations.forEach((organization) => {
          if (organization.value === value) {
            result[i] = {
              Organization: organization.label,
              OrganizationId: organization.value,
            };
          }
        });
      });
      return result;
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppOrganization.vue